import * as React from 'react';
import { Search, X } from 'lucide-react';
import { Entrada } from '@/components/ui/input';
import { Botao } from '@/components/ui/button';

interface BarraBuscaProps {
  valor: string;
  aoMudar: (valor: string) => void;
  placeholder?: string;
  /** Espera o usuário parar de digitar antes de consultar a API. */
  atrasoMs?: number;
}

export function BarraBusca({
  valor,
  aoMudar,
  placeholder = 'Buscar…',
  atrasoMs = 350,
}: BarraBuscaProps) {
  const [texto, setTexto] = React.useState(valor);

  // Mantém o campo em dia quando o filtro é limpo de fora.
  React.useEffect(() => setTexto(valor), [valor]);

  React.useEffect(() => {
    if (texto === valor) return;

    const temporizador = setTimeout(() => aoMudar(texto), atrasoMs);
    return () => clearTimeout(temporizador);
  }, [texto, valor, atrasoMs, aoMudar]);

  return (
    <div className="relative w-full sm:max-w-xs">
      <Search
        className="text-silenciado-texto pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2"
        aria-hidden="true"
      />
      <Entrada
        type="search"
        value={texto}
        onChange={(evento) => setTexto(evento.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        className="pr-9 pl-9"
      />
      {texto && (
        <Botao
          variante="fantasma"
          tamanho="icone"
          className="absolute top-1/2 right-0 size-9 -translate-y-1/2"
          onClick={() => setTexto('')}
          aria-label="Limpar busca"
        >
          <X className="size-4" aria-hidden="true" />
        </Botao>
      )}
    </div>
  );
}
